<template>
  <div class="fs-16 lh-1 white mb-52">
    <span class="db">{{ currentSlide + 1 }}/{{ maxSlide + 1 }}</span>
  </div>
</template>
<script>
import { inject, ref, reactive } from 'vue'
// import Icon from './Icon';
import { defaultConfigs } from './defaults'

export default {
  setup() {
    const config = inject('config', reactive({ ...defaultConfigs }))
    const maxSlide = inject('maxSlide', ref(1))
    const currentSlide = inject('currentSlide', ref(1))

    return {
      config,
      currentSlide,
      maxSlide,
    }
  },
}
</script>
<style lang="scss" scoped>
.carousel__prev,
.carousel__next {
  background-color: var(--vc-nav-background-color);
  border-radius: var(--vc-nav-width);
  width: var(--vc-nav-width);
  height: var(--vc-nav-width);
  text-align: center;
  font-size: calc(var(--vc-nav-width) * 2 / 3);
  padding: 0;
  color: var(--vc-nav-color);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  border: 0;
  cursor: pointer;
}

.carousel__prev {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

.carousel__next {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}
</style>
